import { Component, input, output } from '@angular/core';
import { Collection } from 'app/classes/collection';
import { Report } from 'app/classes/reports/report';

@Component({
  selector: 'app-report-collection-list',
  standalone: false,
  templateUrl: './report-collection-list.component.html',
  styleUrl: './report-collection-list.component.css',
})
export class ReportCollectionListComponent {

  report = input.required<Report>();
  onSelectChange = output<boolean>();

  constructor() {
    console.log('ReportCollectionListComponent');
  }

  toggle(collection: any) {
    collection.selected = !collection.selected;
    this.onSelectChange.emit(true);
  }
}
